import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material'
import React, { useState } from 'react'
import InfoIcon from '@mui/icons-material/Info'
import SmallModal from '../../../../components/Modals/SmallModal'

const NormalAbnormal = ({
  moduleValues,
  setModuleValues,
  fieldName,
  popupHelperText,
  helperTextHeader,
}) => {
  const [openHelper, setOpenHelper] = useState(false)
  return (
    <Grid item xs={12} lg={4}>
      <Box display="flex" alignItems="center">
        {popupHelperText && (
          <Box>
            <IconButton onClick={() => setOpenHelper(true)}>
              <InfoIcon />
            </IconButton>
          </Box>
        )}

        <FormControl fullWidth>
          <InputLabel>{fieldName}</InputLabel>
          <Select
            value={moduleValues?.[fieldName] ?? ''}
            onChange={(e) =>
              setModuleValues((prev) => ({
                ...prev,
                [fieldName]: e.target.value,
              }))
            }
            label={fieldName}
          >
            <MenuItem value="Normal">Normal</MenuItem>
            <MenuItem value="Abnormal">Abnormal</MenuItem>
            <MenuItem value="Patient Unable">Patient Unable</MenuItem>
            <MenuItem value="Patient Refused">Patient Refused</MenuItem>
          </Select>
        </FormControl>
        <SmallModal open={openHelper} onClose={() => setOpenHelper(false)}>
          <Stack>
            <Typography variant="title2" fontSize="1rem" textAlign='center'>
              {helperTextHeader}
            </Typography>
            <Typography textAlign='center'>{popupHelperText}</Typography>
            <Button size='small' color='success' onClick={() => setOpenHelper(false)}>
              Close
            </Button>
          </Stack>
        </SmallModal>
      </Box>
    </Grid>
  )
}

export default NormalAbnormal
